import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
const DEFAULT_TITLE = ' | Разработка Web проектов | Егор Котов'
router.beforeEach((to, from, next) => {
  const lang = (localStorage.lang) ? localStorage.lang : 'ru'
  document.title = to.meta.title[lang] + DEFAULT_TITLE
  next()
});

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
